module.exports = __webpack_public_path__ + "static/media/12.1e218528.jpg";